<template>
  <div>
    <svg class="animate-spin h-5 w-5 mr-3 ..." viewBox="0 0 24 24"></svg>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import {
  isHybridEvent,
  isPhysicalAttendee,
  setStoredParticipationType
} from '@/helpers/redirection-helpers';
export default {
  name: 'PwaLogin',
  computed: {
    ...mapGetters('CurrentEvent', ['getId', 'isLobbyEnabled']),
    ...mapGetters('Authentication', ['isLoggedIn', 'getUser'])
  },
  methods: {
    ...mapActions('Authentication', ['doPasswordlessLogin'])
  },
  created() {
    if (!this.$route.query.otp) {
      this.$router.replace({ name: 'login' });
      return;
    }

    this.doPasswordlessLogin({
      payload: this.$route.query.otp,
      eventId: this.getId,
      visible: this.$route.query.public
    }).then(() => {
      if (this.isLoggedIn) {
        // The home-screen app is the web app: as before WCAG, opening it
        // on a hybrid event makes the attendee physical. Same landing as
        // the login pages: physical -> /program, digital -> /lobby when
        // it's on, else /program.
        if (isHybridEvent()) {
          setStoredParticipationType(this.getUser?.UserID, 'physical');
        }
        this.$router.push({
          name:
            this.isLobbyEnabled && !isPhysicalAttendee() ? 'lobby' : 'program'
        });
      } else {
        this.$notify({
          group: 'default',
          title: this.$t('Views.Login.Otp.linkExpired')
        });
        this.$router.replace({ name: 'login' });
      }
    });
  }
};
</script>
